import {
  customScrollMinimal,
  TableCell,
  TableHeader,
} from '@toggle/design-system';
import styled from 'styled-components';

import { ResultsEmptyState } from '~/views/screener/results-empty-state/ResultsEmptyState';

export const Wrapper = styled.div`
  z-index: 1;
  height: 100%;
`;

export const TableScrollContainer = styled.div`
  position: relative;
  overflow: auto;
  ${customScrollMinimal};
  flex: 1 1 0px;
  min-height: 300px;

  ${ResultsEmptyState.Styled.Container} {
    margin-top: 24px;
  }

  ${ResultsEmptyState.Styled.Message} {
    width: 420px;
    text-align: center;
  }
`;

export const TableRoot = styled.table`
  border-spacing: 0;
  width: 100%;

  --z-index-header-cell: 2;
  --z-index-table-cell: 1;

  tbody tr:hover {
    background-color: var(--surface-hover);
    td {
      background-color: var(--surface-hover);
      [aria-haspopup='true'] {
        border-bottom: 1px dashed var(--border-default);
      }
    }
  }
`;

export const StyledTableCell = styled(TableCell)<{
  $highlight: boolean;
}>`
  background-color: ${props => props.$highlight && 'var(--text-inverse)'};
`;

export const StyledTableHeader = styled(TableHeader)`
  position: sticky;
  top: 0;
  z-index: var(--z-index-app-header);
  cursor: pointer;
`;

export const RankWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const SectorName = styled.span``;

export const FooterRow = styled(TableCell)`
  padding: 20px 0 0 0;
  border-bottom: none;
`;
